export const PROPERTY_OBJECT_TYPES = {
  CONTACT: 'CONTACT'
};
export const PROPERTY_OBJECT_TYPE_IDS = {
  [PROPERTY_OBJECT_TYPES.CONTACT]: '0-1'
};
export const INTEGRATION_STATUS = {
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  CONNECTION_ERROR: 'CONNECTION_ERROR'
};
export const EVENT_STATUS = {
  UPCOMING: 'UPCOMING'
};